import { StateSlice } from '@core/helpers/state-slice';
import { ItemOffer } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromItemOffer from '../actions/item.offer.action';

export type ItemOfferState = StateSlice<ItemOffer>;

export const initialState: ItemOfferState = {
  data: {} as ItemOffer,
  loaded: false,
  loading: false,
  error: null,
  skipped: false,
};

const itemOfferReducer = createReducer(
  initialState,
  on(fromItemOffer.loadItemOffer, () => ({
    ...initialState,
    loading: true,
    loaded: false,
  })),
  on(fromItemOffer.loadItemOfferSuccess, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loading: false,
      loaded: true,
    };
  }),
  on(fromItemOffer.loadItemOfferFail, (_, { payload }) => {
    return {
      ...initialState,
      error: payload,
      loaded: true,
    };
  }),
  on(fromItemOffer.resetItemOffer, () => {
    return {
      ...initialState,
      skipped: true,
    };
  })
);

export function reducer(
  state: ItemOfferState | undefined,
  action: fromItemOffer.ItemOfferActions
) {
  return itemOfferReducer(state, action);
}
